export default [
    {
        path: 'gestor',
        component: () => import(/* webpackChunkName: 'administracao-gestor' */ '@/views/administracao/gestor/Index'),
        redirect: 'gestor/index',
        children: [
            {
                name: 'administracao-gestor-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'administracao-gestor' */ '@/views/administracao/gestor/List.vue'),
            },
            {
                name: 'administracao-gestor-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'administracao-gestor' */ '@/views/administracao/gestor/Form.vue'),
            },
            {
                name: 'administracao-gestor-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
                component: () => import(/* webpackChunkName: 'administracao-gestor' */ '@/views/administracao/gestor/Form.vue'),
            },
        ],
    },
]